export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/array.js
// module id = 465
// module chunks = 4